module.exports = __webpack_public_path__ + "img/Führungsstab.c0e8b184.svg";